import React, { useRef } from 'react';
import InputField from './components/InputField';

const MpiFourWheelInput = ({ item, handleCellEdit, canEditField, inputValues, handleInputChange, handleInputCommit }) => {
  const isRotor = item.name === 'Brake Rotor Specs';
  const labels = isRotor
    ? ['Front Actual', 'Front Min', 'Rear Actual', 'Rear Min']
    : ['L/F', 'R/F', 'L/R', 'R/R'];
  const fields = isRotor
    ? ['front_actual', 'front_min', 'rear_actual', 'rear_min']
    : ['left_front', 'right_front', 'left_rear', 'right_rear'];

  // Create refs for each input field
  const inputRefs = useRef(fields.map(() => React.createRef()));

  // Function to handle tab navigation
  const handleTab = (currentIndex) => {
    const nextIndex = (currentIndex + 1) % fields.length; // Cycle to next field (or wrap around)
    if (inputRefs.current[nextIndex].current) {
      inputRefs.current[nextIndex].current.focus();
    }
  };

  return (
    <div className="row">
      <div className="col-12 mb-2">
        <strong>{item.name || item.description}</strong>
      </div>
      {fields.map((f, i) => (
        <div className="col-md-6" key={f}>
          <label>{labels[i]}</label>
          <InputField
            value={inputValues[`${item.id}-${f}`] ?? item[f] ?? ''}
            onChange={(value) => handleInputChange(item.id, f, value)}
            onBlur={(value) => handleInputCommit({ original: item }, { id: f }, value)}
            editable={canEditField(item, f)}
            className="form-control form-control-sm"
            placeholder=""
            inputRef={inputRefs.current[i]} // Pass ref
            onTab={() => handleTab(i)} // Pass tab handler
          />
        </div>
      ))}
    </div>
  );
};

export default MpiFourWheelInput;